import React, { useContext } from 'react'
import { Embed } from '../../components/Embed'
import { useGetMetabaseSignedUrl } from '../../utils'
import { LotContext } from './LotContext'
import { Empty } from '../../components'

export const LotMetabase = () => {
    const lotContext = useContext(LotContext)
    const { data } = useGetMetabaseSignedUrl(
        569,
        {
            lot_id: lotContext.selectedLot?.id
        },
        !Boolean(lotContext.selectedLot?.id)
    )
    if (!lotContext.selectedLot) {
        return <Empty title="Select a lot first!" />
    }
    if (!data?.metabase_url) return null
    return (
        <div>
            <Embed height={'1500px'} url={data.metabase_url} />
        </div>
    )
}
